import { DataProvider, GetListResult } from 'react-admin'
import { IKSORIS_PARKING_TICKET_CASH_MACHINES_URL } from '../../../api-urls'
import { getWithPagination } from '../../../common/fetch.utils'
import {
  filterParamsComposer,
  queryParamsComposer,
} from '../../../common/get-by-conditions.utils'
import mapSortParam from './automat-api-transactions-sort.mapper'
import filterMapper from './automat-api-transactions-filter.mapper'
import { TransactionInfoResponse } from '../../../dto/device/ticket-machines/automat-api/transaction-info-response'
import { TicketAPIGetListParams } from '../../../common/ticket-api-get-list.params'

const provider = {
  getList: async (
    resource: string,
    {
      filter: { ticketMachineId, ...restFilter },
      sort,
      pagination,
    }: TicketAPIGetListParams,
  ): Promise<GetListResult<TransactionInfoResponse>> => {
    const filterParams = `o=>${filterParamsComposer(
      'o',
      restFilter,
      filterMapper,
    )}`
    const pathParams = queryParamsComposer(sort, pagination, mapSortParam)

    const path = `/${filterParams}${(pathParams && `?${pathParams}`) || ''}`

    const {
      data,
      range: { total },
    } = await getWithPagination<TransactionInfoResponse[]>(
      `${IKSORIS_PARKING_TICKET_CASH_MACHINES_URL}/GetTransactionsInfoByCondition/${ticketMachineId}`,
      path,
    )

    return Promise.resolve({
      data: data.map<TransactionInfoResponse>((d) => ({
        ...d,
        id: d.internalTransactionId,
      })),
      total,
    })
  },
} as DataProvider

export default provider
